import {
  FloatingFormItem,
  InputDate,
  LicensePlateFormField,
} from '@/components/_common';
import EmployeesInfiniteSelectField from '@/components/_common/EmployeesInfiniteSelectField';
import { EmployeeCommissionListRequest } from '@/core/domain/enterprise/EmployeeCommission/EmployeeCommission.types';
import { Col, Form, Input, Modal, ModalProps, Radio, Row } from 'antd';
import { Moment } from 'moment';

interface FormValues
  extends Omit<EmployeeCommissionListRequest, 'from' | 'to'> {
  from?: Moment;
  to?: Moment;
  groupByEmployee?: boolean;
}

const EmployeeCommissionReportModal: React.FC<ModalProps> = (props) => {
  const [form] = Form.useForm<FormValues>();
  const from = Form.useWatch('from', form);
  const to = Form.useWatch('to', form);

  async function handleSubmit() {
    try {
      const values = await form.validateFields();

      const params = new URLSearchParams({
        employeeIds: values.employeeIds?.join() || '',
        from: values.from?.format('YYYY-MM-DD') || '',
        to: values.to?.format('YYYY-MM-DD') || '',
        codeWorkOrder: values?.codeWorkOrder?.toString() || '',
        licensePlate: values?.licensePlate || '',
        customerName: values?.customerName || '',
        groupByEmployee: String(values?.groupByEmployee) || '',
      });

      window.open(
        `/privateReports/employeeCommissions?${params.toString()}`,
        '_blank',
      );
    } catch {}
  }

  return (
    <Modal
      {...props}
      title="Relatório de comissões"
      okText="Gerar relatório"
      destroyOnClose
      onOk={handleSubmit}
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <FloatingFormItem
              name="employeeIds"
              label="Funcionários"
              rules={[{ type: 'array' }]}
            >
              <EmployeesInfiniteSelectField mode="multiple" allowClear />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem name="from" label="Dt. pagamento inicial">
              <InputDate
                disabledDate={(date) => !!to && date.isAfter(to, 'day')}
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem name="to" label="Dt. pagamento final">
              <InputDate
                disabledDate={(date) => !!from && date.isBefore(from, 'day')}
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12} lg={8}>
            <FloatingFormItem name="codeWorkOrder" label="Orçamento">
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12} lg={8}>
            <LicensePlateFormField
              name="licensePlate"
              label="Placa"
              required={false}
            />
          </Col>

          <Col span={24} md={12} lg={8}>
            <FloatingFormItem name="customerName" label="Cliente">
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <Form.Item
              name="groupByEmployee"
              label="Agrupar por funcionário?"
              style={{ margin: 0 }}
              initialValue={false}
            >
              <Radio.Group>
                <Radio value={true}>Sim</Radio>
                <Radio value={false}>Não</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EmployeeCommissionReportModal;
